module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.3.8-236.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.3.8.md
// module id = 679
// module chunks = 296